import ExtendFileAccess from './ExtendFileAccess.component';

export default ExtendFileAccess;